import { render, staticRenderFns } from "./digitalWindowCards.vue?vue&type=template&id=7ddf21b8&"
import script from "./digitalWindowCards.vue?vue&type=script&lang=js&"
export * from "./digitalWindowCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports